exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnWrap[data-v-49a9a1c3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-top:.2rem;margin-bottom:.2rem}.btnWrap div[data-v-49a9a1c3]{width:100%;margin-top:.2rem;text-align:center}.btnWrap div span[data-v-49a9a1c3]{padding:.2rem;background-color:#2891e7;border-radius:.1rem;color:#fff;display:inline-block}.btnWrap .disabled[data-v-49a9a1c3]{opacity:.5}", ""]);

// exports
